/* RD Cart v2.0: optional live Shopify rate verification. No Admin credentials and no client-side rate inventions. */
(()=>{'use strict';
  if(window.__RD_CART_V20_READY__) return; window.__RD_CART_V20_READY__=true;
  const rootPath=()=>{const path=window.Shopify?.routes?.root || '/';return path.endsWith('/')?path:path+'/';};
  const makeURL=(file,params)=>{const url=new URL(rootPath()+'cart/'+file,location.origin);url.search=params.toString();return url;};
  const text=(node,value)=>{if(node)node.textContent=value;};
  const countries=()=>Array.from(document.querySelectorAll('[data-rd-cart-rate-check]'));
  function selectProvince(form){
    const country=form.querySelector('[data-rd-rate-country]');const province=form.querySelector('[data-rd-rate-province]');const wrap=form.querySelector('[data-rd-rate-province-wrapper]');
    if(!country||!province||!wrap)return;
    let list=[];try{list=JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]')}catch(_){list=[]}
    const old=province.value;province.replaceChildren();
    for(const entry of list){if(!Array.isArray(entry)||entry.length<2)continue;const opt=document.createElement('option');opt.value=String(entry[0]);opt.textContent=String(entry[1]);province.append(opt)}
    if(list.length){wrap.hidden=false;if(Array.from(province.options).some(o=>o.value===old))province.value=old}else wrap.hidden=true;
  }
  function initForm(form){
    if(form.dataset.rdInitialized==='1')return;form.dataset.rdInitialized='1';
    const country=form.querySelector('[data-rd-rate-country]');
    if(!country)return;
    const iso=(form.dataset.country||'').toUpperCase();
    const matched=Array.from(country.options).find(o=>(o.dataset.code||'').toUpperCase()===iso);
    if(matched)country.value=matched.value;
    selectProvince(form);
  }
  function reconcileExpressMinimums(){
    document.querySelectorAll('[data-section-type="cart-template"]').forEach(section=>{
      const note=section.querySelector('.js-cart-footer-button-message');
      const wallets=section.querySelector('.js-cart-footer-additional-buttons');
      if(!note||!wallets)return;
      const min=Number(note.getAttribute('data-amount-cents'))*(Number(window.Shopify?.currency?.rate)||1);
      const total=Number(note.getAttribute('data-cart-total'));
      if(!(min>0)||!Number.isFinite(total))return;
      wallets.classList.toggle('is-hidden',total<min);
    });
  }
  let scanPending=false;
  function scan(){scanPending=false;countries().forEach(initForm);reconcileExpressMinimums()}
  function schedule(){if(scanPending)return;scanPending=true;requestAnimationFrame(scan)}
  document.addEventListener('change',event=>{
    const form=event.target.closest('[data-rd-cart-rate-check]');if(!form)return;
    if(event.target.matches('[data-rd-rate-country]'))selectProvince(form);
    abortRequest(form);const result=form.querySelector('[data-rd-rate-result]');text(result,'');
  });
  document.addEventListener('input',event=>{const form=event.target.closest('[data-rd-cart-rate-check]');if(form&&event.target.matches('[data-rd-rate-postal]')){abortRequest(form);text(form.querySelector('[data-rd-rate-result]'),'')}});
  const sleep=ms=>new Promise(done=>setTimeout(done,ms));
  const requests=new WeakMap();
  const abortRequest=form=>{const controller=requests.get(form);if(controller){controller.abort();requests.delete(form);form.dataset.rdLoading='0';const button=form.querySelector('[data-rd-rate-submit]');if(button)button.disabled=false;}};
  async function readJSON(response){const body=await response.text();let data;try{data=JSON.parse(body)}catch(_){throw new Error('Shopify returned an unexpected response. Please try again.')}
    if(!response.ok){const description=typeof data?.description==='string'?data.description:'Shipping rates could not be calculated.';throw new Error(description)}return data;
  }
  async function calculate(form){
    if(form.dataset.rdLoading==='1')return;
    form.dataset.rdLoading='1';
    const button=form.querySelector('[data-rd-rate-submit]');const result=form.querySelector('[data-rd-rate-result]');
    button.disabled=true;text(result,'Checking available rates with Shopify…');
    const country=form.querySelector('[data-rd-rate-country]').value;
    const province=form.querySelector('[data-rd-rate-province-wrapper]').hidden?'':form.querySelector('[data-rd-rate-province]').value;
    const zip=form.querySelector('[data-rd-rate-postal]').value.trim();
    const params=new URLSearchParams();params.set('shipping_address[country]',country);params.set('shipping_address[province]',province);params.set('shipping_address[zip]',zip);
    const controller=new AbortController();requests.set(form,controller);
    try{
      const post=await fetch(makeURL('prepare_shipping_rates.json',params),{method:'POST',credentials:'same-origin',signal:controller.signal});
      const prepared=await readJSON(post);
      if(prepared && typeof prepared==='object' && !Array.isArray(prepared)){
        const problems=Object.values(prepared).flat().map(String).filter(Boolean);
        throw new Error(problems.join(' ')||'Please check your delivery address.');
      }
      let rates=null;
      for(let attempt=0;attempt<10;attempt++){
        if(attempt)await sleep(650);
        const response=await fetch(makeURL('async_shipping_rates.json',params),{credentials:'same-origin',signal:controller.signal});
        const data=await readJSON(response);
        if(data && Array.isArray(data.shipping_rates)){rates=data.shipping_rates;break;}
      }
      if(!form.isConnected||requests.get(form)!==controller)return;
      if(!rates){text(result,'Shipping calculation is taking longer than expected. Please retry.');return;}
      result.replaceChildren();
      const notice=document.createElement('strong');
      if(!rates.length)notice.textContent='No rates available for this destination.';
      else if(rates.some(rate=>Number(rate.price)===0))notice.textContent='A free shipping option is currently estimated for this destination.';
      else notice.textContent='Available estimated shipping rates:';
      result.append(notice);
      if(rates.length){const ul=document.createElement('ul');ul.className='rd-cart-rate__rates';
        for(const rate of rates){const li=document.createElement('li');const amount=Number(rate.price);const currency=rate.currency||form.dataset.currency||'USD';
          let money=String(rate.price);
          try{if(Number.isFinite(amount))money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(amount)}catch(_){}
          li.textContent=String(rate.name||'Shipping')+': '+(Number.isFinite(amount)&&amount===0?'Free':money);
          ul.append(li)
        }
        result.append(ul);
      }
      form.dispatchEvent(new CustomEvent('rd:shipping:estimate',{bubbles:true,detail:{free_option:rates.some(rate=>Number(rate.price)===0),count:rates.length}}));
    }catch(error){if(form.isConnected&&requests.get(form)===controller&&error?.name!=='AbortError')text(result,error?.message||'Shipping estimate failed. Please try again.');}
    finally{if(requests.get(form)===controller){requests.delete(form);button.disabled=false;form.dataset.rdLoading='0';}}
  }
  document.addEventListener('click',event=>{const button=event.target.closest('[data-rd-rate-submit]');if(!button)return;const form=button.closest('[data-rd-cart-rate-check]');if(form)calculate(form)});
  // A cart change invalidates previous shipping estimates even if the theme keeps its footer DOM.
  function invalidate(){countries().forEach(form=>{abortRequest(form);text(form.querySelector('[data-rd-rate-result]'),'')});schedule()}
  for(const evt of ['rd:cart:mutated','cart:updated','cart:refresh','shopify:cart:lines-update','shopify:cart:discount-update']){
    document.addEventListener(evt,invalidate);
  }
  if(window.themeCore?.EventBus?.listen){
    window.themeCore.EventBus.listen('cart:updated',invalidate);
    window.themeCore.EventBus.listen('cart:refresh',invalidate);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
  if(document.body){new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});}
})();
